// SHOULD MATCH IN FE AND API REPOS
import { z } from 'zod';

export type Dealer = z.TypeOf<typeof DealerSchema>;

export enum DealerEmailTemplate {
  Default = 'default',
  FuturaTrailersInc = 'futura-trailers-inc-template',
}

export const DealerProfileFileSchema = z.object({
  fileName: z.string(),
  fileUrl: z.string(),
  uploadedBy: z.string().optional(),
  uploadedBySub: z.string().optional(),
  uploadedAt: z.number().optional(),
  publicUrl: z.string().optional(),
});

export type DealerProfileFile = z.infer<typeof DealerProfileFileSchema>;

export const DealerSchema = z.object({
  id: z.string(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  isArchived: z.boolean().optional(),

  companyName: z.string().min(2),
  bankName: z.string().optional(),
  phone: z.string(),
  websiteUrl: z.string().optional(),
  emailAddresses: z.array(z.string()),
  emailTemplate: z.nativeEnum(DealerEmailTemplate),
  customThemeContent: z.string().optional(),
  address: z.object({
    addressLine1: z.string(),
    addressLine2: z.string().optional(),
    city: z.string(),
    state: z.string(),
    zipCode: z.string(),
  }),
  documents: z.array(DealerProfileFileSchema).default([]),
});
